import type { TableHeaderRow } from '@shared/table-generator';

import type { ActionPermissionType } from '../../types';

export interface PermissionListColumn extends Omit<TableHeaderRow, 'children'> {
  children: (TableHeaderRow['children'][number] & {
    type: 'feature' | ActionPermissionType;
  })[];
}

export const columns: PermissionListColumn[] = [
  {
    children: [
      {
        type: 'feature',
        children: 'Feature',
        align: 'center',
      },
      {
        type: 'view',
        children: 'View',
        width: '128px',
        align: 'center',
      },
      {
        type: 'update',
        children: 'Update',
        width: '128px',
        align: 'center',
      },
      {
        type: 'create',
        children: 'Create',
        width: '128px',
        align: 'center',
      },
      {
        type: 'status',
        children: 'Change Status',
        align: 'center',
        width: '129px',
      },
      {
        type: 'delete',
        children: 'Delete',
        width: '128px',
        align: 'center',
      },
    ],
  },
];

export const columnsWithoutStatus: PermissionListColumn[] = [
  {
    children: [
      {
        type: 'feature',
        children: 'Feature',
        align: 'center',
      },
      {
        type: 'view',
        children: 'View',
        width: '128px',
        align: 'center',
      },
      {
        type: 'update',
        children: 'Update',
        width: '128px',
        align: 'center',
      },
      {
        type: 'create',
        children: 'Create',
        width: '128px',
        align: 'center',
      },
      {
        type: 'delete',
        children: 'Delete',
        width: '128px',
        align: 'center',
      },
    ],
  },
];
